import { render } from "./ms-sidebar-cart-item.vue?vue&type=template&id=51ef2e72&scoped=true"
import script from "./ms-sidebar-cart-item.vue?vue&type=script&lang=js"
export * from "./ms-sidebar-cart-item.vue?vue&type=script&lang=js"

import "./ms-sidebar-cart-item.vue?vue&type=style&index=0&id=51ef2e72&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\agco-ecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ef2e72"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn});
